import * as angular from "angular";
import {IController} from "angular";

export class programServiceAreasByPackageSizeTableCtrl implements IController {

  zones: any;
  isExpanded: boolean;
  serviceAreasOptionIds: string[];
  excludeServiceAreasIds: string[];
  packagesOptionsIds: string[];
  onUpdateZone: Function;
  onDeleteZone: Function;

  /* @ngInject */
  constructor() {
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreasByPackageSizeTable', {
    bindings: {
      zones: '<',
      isExpanded: '<?',
      serviceAreasOptionIds: '<?',
      excludeServiceAreasIds: '<?',
      packagesOptionsIds: '<',
      onUpdateZone: '&',
      onDeleteZone: '&'
    },
    template: require('./program-service-areas-by-package-size-table.html').default,
    controller: programServiceAreasByPackageSizeTableCtrl
  });
